import * as React from 'react';

import { expandIcon } from '../../images';

const lightbulbIcon = <img alt="Lightbulb icon for helpful tips" src={`${window.postbuildEnv.CDN_URL}/images/pages/activity_analysis/lightbulb.svg`} />

const TipSection = ({ toggleSection, index, openStates, section, }) => {
  function handleClick() { toggleSection(index)}

  if (section.isDisabled) {
    return (
      <div className="toggle-student-report-explanation scoring-explanation is-closed">
        <span />
        <h4>{section.headerText}</h4>
      </div>
    )
  }

  if (openStates[index]) {
    return (
      <div className="toggle-student-report-explanation is-open" key={index}>
        <button aria-expanded={true} className="toggle-student-report-explanation-header focus-on-light" onClick={handleClick} type="button">
          <img alt="" src={expandIcon.src} />
          <h4>{section.headerText}</h4>
        </button>
        <div className="body">{section.body}</div>
      </div>
    )
  }

  return (
    <button aria-expanded={false} className="toggle-student-report-explanation scoring-explanation is-closed focus-on-light" onClick={handleClick} type="button">
      <img alt="" src={expandIcon.src} />
      <h4>{section.headerText}</h4>
    </button>
  )

}

export const HelpfulTips = ({ sections, header }) => {
  const [openStates, setOpenStates] = React.useState(sections.map(() => false));

  function toggleSection(index) {
    const newOpenStates = [...openStates];
    newOpenStates[index] = !newOpenStates[index];
    setOpenStates(newOpenStates);
  };

  return (
    <aside className="helpful-tips">
      <div className="helpful-tips-header">
        {lightbulbIcon}
        {header}
      </div>
      {sections.map((section, index) => (
        <TipSection
          index={index}
          key={section.headerText}
          openStates={openStates}
          section={section}
          toggleSection={toggleSection}
        />
      ))}
    </aside>
  );
};
